var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.5781 6.26725C20.876 6.56706 21.0899 6.93986 21.1985 7.34833C21.5999 8.85596 21.5999 12 21.5999 12C21.5999 12 21.5999 15.144 21.1985 16.6516C21.0899 17.0601 20.876 17.4329 20.5781 17.7327C20.2802 18.0325 19.9088 18.2488 19.501 18.36C17.9999 18.7636 11.9999 18.7636 11.9999 18.7636C11.9999 18.7636 5.9999 18.7636 4.49881 18.36C4.09105 18.2488 3.71963 18.0325 3.42173 17.7327C3.12384 17.4329 2.90991 17.0601 2.80136 16.6516C2.3999 15.144 2.3999 12 2.3999 12C2.3999 12 2.3999 8.85596 2.80136 7.34833C2.90991 6.93986 3.12384 6.56706 3.42173 6.26725C3.71963 5.96744 4.09105 5.75113 4.49881 5.63996C5.9999 5.23633 11.9999 5.23633 11.9999 5.23633C11.9999 5.23633 17.9999 5.23633 19.501 5.63996C19.9088 5.75113 20.2802 5.96744 20.5781 6.26725ZM15.0545 12L10.0363 9.14508V14.8549L15.0545 12Z","fill":"#1C232B"}));
}

Youtube.displayName = "Youtube";

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
